
<template>
  <div class="employee-deparrment-table">
    <div class="header-title">Thống kê nhân sự Fabbi Group</div>
    <div class="table-options">
      <!-- <div class="explain-label">
        <div>
          <span>Nhân sự đầu kỳ: </span> là nhân sự cuối kỳ của tháng trước
        </div>
        <div>
          <span> Nhân sự cuối kỳ (tháng):</span> là nhân sự tính đến thời điểm
          cuối tháng
        </div> -->
      <!-- </div> -->
      <div class="options">
        <div class="options-item">
          <input
            :disabled="showMonth && !showQuarter && !showYear"
            type="checkbox"
            v-model="showMonth"
          />
          Tháng
        </div>
        <div class="options-item">
          <input
            :disabled="!showMonth && showQuarter && !showYear"
            type="checkbox"
            v-model="showQuarter"
          />
          Quý
        </div>
        <div class="options-item">
          <input
            :disabled="!showMonth && !showQuarter && showYear"
            type="checkbox"
            v-model="showYear"
          />
          Năm
        </div>
        <a-select
          mode="multiple"
          placeholder="Công ty"
          size="large"
          option-label-prop="label"
          v-model="listSelectedCompany"
          @select="handleSelectCompany"
          @deselect="handleSelectCompany"
          :showArrow="true"
          :maxTagCount="1"
          class="select__drop"
          @blur="updateTableData"
        >
          <template #suffixIcon>
            <div>
              <img src="../../assets/img/arrow.svg" alt="" />
            </div>
          </template>
          <a-select-option 
              key="companyAll"
              label="All">
            <a-checkbox v-model="checkAll"> </a-checkbox>
            All
          </a-select-option>
          <a-select-option
            v-for="(option, index) in companyOptions"
            :key="'company' + index"
            :value="option.value"
            :label="option.label"
          >
            <a-checkbox v-model="option.isChecked"> </a-checkbox>
            {{ option.label }}
          </a-select-option>
        </a-select>
        <a-select
          mode="multiple"
          placeholder="Lựa chọn năm"
          size="large"
          option-label-prop="label"
          v-model="listSelectedyear"
          @select="handleSelectYear"
          @deselect="handleSelectYear"
          :showArrow="true"
          :maxTagCount="1"
          class="select__drop"
          @blur="updateTableData"
        >
          <template #suffixIcon>
            <div>
              <img src="img/icons/arrow.svg" alt="" />
            </div>
          </template>

          <a-select-option
            v-for="(option, index) in listYear"
            :key="index"
            :value="option.value"
            :label="option.value"
          >
            <a-checkbox v-model="option.isChecked"> </a-checkbox>
            {{ option.value }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div class="table-list" v-if="Object.keys(tableData).length > 0">
      <EmployeeTable
        v-for="(item, index) in tableData"
        v-bind:key="index"
        :tableData="item"
        :showMonth="showMonth"
        :showQuarter="showQuarter"
        :showYear="showYear"
      />
    </div>
    <div v-else class="table-no-data">No Data</div>
  </div>
  <!-- </div> -->
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import EmployeeTable from "./EmployeeTable.vue";
import moment from "moment";

export default {
  name: "DashboardTable",
  components: {
    EmployeeTable,
  },
  data() {
    return {
      tableData: {},
      listYear: [],
      companyOptions: [],
      showMonth: true,
      showQuarter: false,
      showYear: false,
      listSelectedyear: [],
      listSelectedCompany: [],
      checkAll: false,
      updateAvailable: true,
    };
  },
  computed: {
    ...mapGetters({
      companies: "commons/companies",
      employeeSeniority: "dashboard/employeeSeniority",
    }),
  },
  async created() {
    await this.getListCompany();
    await this.getYearOptionList();
    await this.updateTable();
  },
  watch: {
    listSelectedyear() {
      if (this.listSelectedyear.length !== 0) {
        this.updateAvailable = true;
      }
    },
    listSelectedCompany() {
      this.listSelectedCompany.length === this.companyOptions.length
        ? (this.checkAll = true)
        : (this.checkAll = false);

      if (this.listSelectedCompany.length !== 0) {
        this.updateAvailable = true;
      }
    },
  },

  methods: {
    ...mapActions("layout", ["setLoading"]),
    async updateTable() {
      if (this.updateAvailable) {
        this.setLoading(true);
        await this.$store.dispatch("dashboard/getEmployeeesSeniority", {
          params: { arrYears: this.listSelectedyear, codes: this.listSelectedCompany },
        });
        const reverseData = Object.values(this.employeeSeniority).reverse();
        this.tableData = reverseData;
        this.updateAvailable = false;
        this.setLoading(false);
      }
    },
    getYearOptionList() {
      var listOption = [];
      const currentYear = moment().year();
      listOption.push({
        value: currentYear,
        isChecked: true,
      });
      for (let i = currentYear - 1; i >= 2018; i--) {
        const yearOption = {
          value: i,
          isChecked: false,
        };
        listOption.push(yearOption);
      }
      this.listSelectedyear.push(currentYear);
      this.listYear = listOption;
    },
    getListCompany() {
      Object.keys(this.companies).forEach((item) => {
        this.companyOptions.push({
          label: this.companies[item].name,
          value: item,
          isChecked: false,
        });
      });
      this.handleCheckAll();
    },
    handleCheckAll() {
      let selecetedList = [];
      for (let i = 0; i < this.companyOptions.length; i++) {
        if (this.checkAll === false) {
          this.companyOptions[i].isChecked = true;
          selecetedList.push(this.companyOptions[i].value);
        } else {
          this.companyOptions[i].isChecked = false;
        }
      }
      this.listSelectedCompany = selecetedList;
      
    },
    handleSelectCompany(e) {
      if (e === "companyAll") {
        this.handleCheckAll(true);
      } else {
        let key = Object.keys(this.companyOptions).find(
          (key) => this.companyOptions[key].value === e
        );
        if (key) {
          this.companyOptions[key].isChecked =
            !this.companyOptions[key].isChecked;
        }
      }
    },
    handleSelectYear(e) {
      let key = Object.keys(this.listYear).find(
        (key) => this.listYear[key].value === e
      );
      if (key) {
        this.listYear[key].isChecked = !this.listYear[key].isChecked;
      }
    },
    updateTableData() {
      if (this.listSelectedyear.length === 0 || this.listSelectedCompany.length === 0) {
        this.tableData={};
        return;
      }
      this.updateTable();
    },
  },
};
</script>

<style lang="scss" scoped>
.employee-deparrment-table {
  background: #ffffff;
  border: 1px solid #efefef;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 30px 42px;
  margin-top: 15px;
  font-weight: 400;
  font-size: 14px;
  color: #303c54;
  min-width: 100%;
  .header-title {
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #303c54;
    margin-bottom: 30px;
  }
  .table-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-direction: row-reverse;
    .explain-label {
      font-weight: 400;
      font-size: 14px;
      color: #303c54;
      span {
        font-weight: 700;
      }
    }
    .options {
      display: flex;
      flex-wrap: wrap;
      &-item {
        margin-right: 14px;
        align-items: center;
        display: flex;
      }
      input[type="checkbox"] {
        width: 16px;
        height: 16px;
        border: 1px solid #cfcfcf;
        border-radius: 2px;
        margin-right: 10px;
      }
      .select__drop {
        width: 140px;
        &:last-child {
          margin-left: 10px;
        }
      }
    }
  }
  .table-list {
    width: 100%;
  }
  .table-no-data {
    text-align: center;
    font-size: 20px;
    color: #cfcfcf;
  }
  @media only screen and (max-device-width: 480px) {
    padding: 30px 20px;
  }
}
</style>

<style lang="scss">
.table-options {
  .ant-select-selection__placeholder {
    font-size: 14px;
  }
  .ant-select-selection__rendered li,
  .ant-select-selection__choice__disabled li {
    height: 25px !important;
    line-height: 25px !important;
    margin-top: 7px !important;
    padding: 0 5px 0 5px !important;
    font-size: 14px !important;
  }
  .ant-select-selection__choice__remove {
    display: none !important;
  }
  .ant-select-selection--multiple .ant-select-selection__choice__content{
    max-width: 40px;
  }
}
</style>
